import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";

const FAQS = [
  {
    q: "Are we the right fit for you?",
    a: "Most clients are doing ₹40 lakh to ₹40 crore in yearly revenue and want to double or triple that in the next 18 months. We take on earlier-stage founders when there's real product-market fit — and enterprise engagements up to ₹200 crore when the scope is meaty. If you're pre-revenue or looking for a one-off deliverable, we'll politely point you elsewhere.",
  },
  {
    q: "How long do we lock you in?",
    a: "We don't. Quarter-to-quarter after the initial 90-day sprint. If we're not moving the number, you walk. That's the whole contract. No auto-renewals, no exit fees.",
  },
  {
    q: "Do you actually run every channel in-house?",
    a: "Yes — ads, SEO, CRO, social, email, web, app and brand are all shipped by our own team. If it's not our discipline (say, PR or influencer seeding at scale), we say so upfront and hand you off to a partner we've personally vetted.",
  },
  {
    q: "How do you charge?",
    a: "Flat monthly retainer, agreed upfront, based on scope. We never charge a percentage of your ad spend — that's how founders quietly get bled by agencies telling them to spend more. Performance-based add-ons available for the right engagements.",
  },
  {
    q: "Where's the team?",
    a: "Mumbai HQ (Andheri), working India + UK hours. For US clients we schedule around your evening. Our operators have shipped from three continents — time zones are a solved problem.",
  },
  {
    q: "Do you white-label web and app work?",
    a: "Never. Every site and app you see in our portfolio was designed and coded by our in-house product team. That's how we hold the taste bar and the timeline at the same time.",
  },
];

const Row = ({ q, a, i, open, onToggle }) => (
  <div className="border-b border-white/10" data-testid={`faq-${i}`}>
    <button
      onClick={onToggle}
      data-testid={`faq-toggle-${i}`}
      className="flex w-full items-center justify-between py-6 text-left transition-colors hover:text-white"
    >
      <span className="pr-8 font-display text-xl font-bold tracking-tight text-white md:text-2xl">
        {q}
      </span>
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-white/15 text-white">
        {open ? <Minus size={16} /> : <Plus size={16} />}
      </span>
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className="overflow-hidden"
        >
          <p className="max-w-3xl pb-6 text-white/75 leading-relaxed">{a}</p>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section
      id="faq"
      data-testid="faq"
      className="relative border-t border-white/10 py-24 md:py-32"
    >
      <div className="mx-auto max-w-[90rem] px-6 md:px-12">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/65">
          / Answers, no sales voice
        </p>
        <h2 className="mt-5 max-w-2xl font-display text-4xl font-extrabold leading-[0.95] tracking-tighter text-white md:text-6xl">
          The questions founders{" "}
          <span className="font-serif-emph font-normal">WhatsApp us</span>{" "}
          at midnight.
        </h2>

        <div className="mt-12 max-w-4xl border-t border-white/10">
          {FAQS.map((f, i) => (
            <Row
              key={i}
              q={f.q}
              a={f.a}
              i={i}
              open={open === i}
              onToggle={() => setOpen(open === i ? -1 : i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
